import MainPrivacyPolicy from './MainPrivacyPolicy.svelte';

const app = new MainPrivacyPolicy({
	target: document.body,
});

export default app;
